import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { trackDeleteTemplateWeekShiftManagementSubmit } from 'modules/shift_management/lib/trackEvents'
import templateWeeks from 'modules/shift_management/store/api/collections/templateWeeks'

type ModalProps = React.ComponentProps<typeof Modal>

interface Props {
  onCancel: ModalProps['onClose']
  weekId: string
  shiftTemplateId: string
}

const DeleteWeek = ({ weekId, shiftTemplateId, onCancel }: Props) => {
  const templateWeek = templateWeeks.get(weekId)
  const name = templateWeek?.attributes.name

  const title = i18n.t('shift_management.rotating_shifts.schedules.delete')
  const description = i18n.t('shift_management.rotating_shifts.schedules.delete_unused', { name })

  const { running, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      if (!templateWeek) return

      await templateWeek.destroy()
      closePortal()

      trackDeleteTemplateWeekShiftManagementSubmit(shiftTemplateId, weekId)
    }
  )

  return (
    <Modal
      illustration="delete-cross"
      title={title}
      description={description}
      onClose={onCancel}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onCancel}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" disabled={running} submit>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(DeleteWeek)
